import invoicesTypes from "./invoices.types";

export const getAllInvoicesActions =(payload,cb,cbError)=>({
    type:invoicesTypes.GET_ALL_INVOICES,
    payload,
    cb,
    cbError
})
